import React, { useRef, useMemo } from 'react';
import PropTypes from 'prop-types';
import { useJsData } from '@bingads-webui-cc-react/js-data-rest';
import {
  getHomePageCardData,
  AddAssetEntryCard,
  RealUsedFlagSuffix,
  handleRealUsedFlag,
  isValidXandrAccount,
} from '@bingads-webui-campaign-react/ads-studio-app-shared-components';

import { useActionAssetCardsStyle } from '../../../home-page-styles/component-styles/home-page-action-asset-cards';

export const ActionAssetCards = ({
  i18n,
  aid,
  cid,
  oDataConfig,
  navigation,
  logger,
  adsStudioAccountPreferences,
  permissions,
}) => {
  const classes = useActionAssetCardsStyle();
  const openSystemUploadRef = useRef(null);

  const isXandrIntEnabled = useMemo(() => permissions.dynamic.XandrIntegrationEnabled, [permissions]);
  // eslint-disable-next-line no-restricted-globals
  const { data: account } = useJsData(jsData => (isXandrIntEnabled ? jsData.Account.find(aid) : Promise.resolve()), [aid, isXandrIntEnabled]);
  const isXandrIntegrationEnabled = useMemo(() => (isXandrIntEnabled ? isValidXandrAccount(account) : false), [account, isXandrIntEnabled]);

  const cardData = useMemo(() => getHomePageCardData({
    i18n,
    onClickUpload: () => {
      handleRealUsedFlag(adsStudioAccountPreferences, RealUsedFlagSuffix.App);
      openSystemUploadRef.current = {};
      navigation.gotoUploadFilesPanelPage({
        aid, cid, oDataConfig, i18n, mode: 'image', openSystemUpload: openSystemUploadRef.current,
      });
    },
    onClickStock: () => {
      handleRealUsedFlag(adsStudioAccountPreferences, RealUsedFlagSuffix.App);
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from shutterstock');
      }
      navigation.gotoStockImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickInvest: () => {
      handleRealUsedFlag(adsStudioAccountPreferences, RealUsedFlagSuffix.App);
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from invest');
      }
      navigation.gotoInvestImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    onClickWebsite: () => {
      handleRealUsedFlag(adsStudioAccountPreferences, RealUsedFlagSuffix.App);
      if (logger && logger.logTrace) {
        logger.logTrace('Add asset from website');
      }
      navigation.gotoWebsiteImagePanelPage({
        aid, cid, oDataConfig, i18n,
      });
    },
    isXandrIntegrationEnabled,
  }), [i18n, adsStudioAccountPreferences, navigation, aid, cid, oDataConfig, logger, isXandrIntegrationEnabled]);

  return (
    <>
      <div className={classes.cardContainer}>
        {cardData.map(card => (
          <AddAssetEntryCard
            key={card.key}
            id={card.key}
            description={card.description}
            title={card.title}
            imageSrc={card.image}
            onClick={card.onClick}
            isFillWidth
          />
        ))}
      </div>
    </>
  );
};

ActionAssetCards.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  aid: PropTypes.number.isRequired,
  cid: PropTypes.number.isRequired,
  oDataConfig: PropTypes.shape({}).isRequired,
  navigation: PropTypes.shape({
    gotoWebsiteImagePanelPage: PropTypes.func,
    gotoStockImagePanelPage: PropTypes.func,
    gotoUploadFilesPanelPage: PropTypes.func,
    gotoInvestImagePanelPage: PropTypes.func,
  }).isRequired,
  logger: PropTypes.shape({
    logTrace: PropTypes.func,
  }).isRequired,
  permissions: PropTypes.shape({
    dynamic: PropTypes.shape({}),
  }),
};

ActionAssetCards.defaultProps = {
  permissions: { dynamic: {} },
};
